export const replaceCurrencySymbol = (value: string, symbol: string): string => {
  return value.replace(new RegExp(`${ '\\' + symbol }`, 'gi'), '');
}
